export default __webpack_public_path__ + "static/media/misc-books1-1024w.8e66a2e8.avif";